/* eslint-disable no-param-reassign */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-shadow */
/* eslint-disable no-mixed-operators */
import React, { useState, useEffect, useRef } from 'react'
import round from 'lodash/round'
import classNames from 'classnames'
import { message } from 'antd'
import qs from 'qs'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import util from 'meinian-package/src/utils/util'
import request from 'meinian-package/src/utils/request'
import { getUserInfo } from 'meinian-package/src/common/userInfo'
import isIPad from 'meinian-package/src/common/isIPad'
import Note from './note'
import './index.less'

const MAX_SCALE = 2
const LEFT = 214

const babelMouseEvent = (e) => {
  if (isIPad) {
    e.clientX = e.changedTouches?.[0]?.clientX || e.clientX
    e.clientY = e.changedTouches?.[0]?.clientY || e.clientY
  }
}

export default (props) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const {
    imageInfo,
    originImage,
    className,
    scale,
    setScale,
    isAnnotate,
    setIsAnnotate,
    notes,
    setNotes,
    fetchNotes,
    isMove,
    onChange,
    setIsMove,
    activeNoteIndex,
    setActiveNoteIndex,
    isDraw,
    setIsDraw,
    innerIndex,
    showRight,
  } = props
  const userInfo = getUserInfo()
  const { sampleCode } = imageInfo
  const sampleId = imageInfo.id
  const sampleInspirationId = imageInfo.inspirationId

  const { imageGroupEntityId, inspirationId, collectId } = imageInfo || {}
  const [loading, setLoading] = useState(false)
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0, height: 0 })
  const [isDarg, setIsDrag] = useState(false)
  const $container = useRef(null)
  const $wrapper = useRef(null)
  const dragStartPos = useRef({})
  const drawStartPos = useRef({})
  const moveStartPos = useRef({})

  const hasMousePc = (e) => {
    if (e?.button === 2 && !isIPad) {
      return true
    }
    return false
  }

  useEffect(() => {
    if (!imageGroupEntityId && !sampleId) { return }
    init()
    setIsAnnotate(false)
  }, [imageGroupEntityId, sampleId, scale, innerIndex])

  useEffect(() => {
    const calculate = () => {
      calculatePosition(originImage)
    }
    calculate()
    window.addEventListener('resize', calculate)
    if (isIPad) {
      window.removeEventListener('resize', calculate)
    }
    return () => window.removeEventListener('resize', calculate)
  }, [$container.current, originImage, showRight])

  const init = () => {
    setLoading(true)
    calculatePosition({ ...originImage, scale })
    setLoading(false)
  }

  useEffect(() => {
    if (!isAnnotate) {
      onCancel(notes[activeNoteIndex])
    }
  }, [isAnnotate])

  const calculatePosition = ({ width, height, scale, translate }) => {
    const canvasWidth = $container.current?.clientWidth
    const canvasHeight = isIPad ? document.body.clientHeight : $container.current?.clientHeight

    const origin = (translate || scale) ? { x: position.left + position.width / 2, y: position.top + position.height / 2 }
      : { x: canvasWidth / 2, y: canvasHeight / 2 }
    if (!translate && !scale) {
      if ((width / height) > (canvasWidth / canvasHeight)) {
        position.width = canvasWidth
        position.height = height * canvasWidth / width
        if (position.width / width > MAX_SCALE) {
          position.width = width * MAX_SCALE
          position.height = height * MAX_SCALE
          setScale(MAX_SCALE)
        } else {
          setScale(position.width / width)
        }
      } else {
        position.height = canvasHeight
        position.width = width * canvasHeight / height
        if (position.width / width > MAX_SCALE) {
          position.width = width * MAX_SCALE
          position.height = height * MAX_SCALE
          setScale(MAX_SCALE)
        } else {
          setScale(position.height / height)
        }
      }
    }
    if (scale) {
      position.width = width * scale
      position.height = height * scale
    }
    position.top = origin.y - position.height / 2
    position.left = origin.x - position.width / 2
    if (translate) {
      position.left = translate.x
      position.top = translate.y
    }
    setPosition({ ...position })
  }

  const dragStart = (e) => {
    if (hasMousePc(e)) return
    babelMouseEvent(e)
    dragStartPos.current = { x: (e.clientX - LEFT) - position.left, y: e.clientY - position.top }
    setIsDrag(true)
  }
  const drawStart = (e) => {
    if (!isAnnotate) return
    e?.stopPropagation()
    babelMouseEvent(e)
    drawStartPos.current = { x: (e.clientX - LEFT), y: e.clientY }
    setIsDraw(true)
    const newNotes = notes.filter(m => m.confirm)
    newNotes.unshift({
      confirm: false,
      isShowNote: true,
      xmin: ((e.clientX - LEFT) - position.left) / position.width,
      ymin: (e.clientY - position.top) / position.height,
      xmax: ((e.clientX - LEFT) - position.left) / position.width,
      ymax: (e.clientY - position.top) / position.height
    })
    setNotes(newNotes)
    setActiveNoteIndex(0)
  }
  const move = {
    start(index, e) {
      if (hasMousePc(e)) return
      e && e.stopPropagation()
      setActiveNoteIndex(index)
      const note = notes[index]
      setNotes(pre => {
        return pre.map((item, i) => {
          if (index === i) {
            if (item?.isShowNote && item.confirm) {
              return { ...item, isShowNote: false, editMode: false }
            }
            return { ...item, isShowNote: true }
          }
          return { ...item, isShowNote: false, editMode: false }
        })
      })
      if (note.confirm && userInfo.userId !== note.userId) return
      babelMouseEvent(e)
      moveStartPos.current = { x: (e.clientX - LEFT), y: e.clientY }
      setIsMove(true)
    }
  }
  const saveNote = async (note) => {
    let params = {}
    if (sampleId) {
      params = {
        annotationContent: note.annotationContent,
        annotationUrl: note?.annotationUrl || '',
        entityId: sampleId,
        inspirationId: sampleInspirationId,
        mainUrl: imageInfo.mainUrl,
        targetId: sampleCode,
        xmax: round(note.xmax, 4),
        xmin: round(note.xmin, 4),
        ymax: round(note.ymax, 4),
        ymin: round(note.ymin, 4),
        type: 1
      }
    } else {
      params = {
        annotationContent: note?.annotationContent || '',
        annotationUrl: note?.annotationUrl || '',
        entityId: imageGroupEntityId,
        inspirationId,
        mainUrl: imageInfo.mainUrl,
        targetId: collectId,
        xmax: round(note.xmax, 4),
        xmin: round(note.xmin, 4),
        ymax: round(note.ymax, 4),
        ymin: round(note.ymin, 4),
        type: 0
      }
    }
    try {
      await request.post('/zhikuan/annotation/save-blog-annotation', params)
      onChange?.({ annotationNum: Number(notes?.length) })
    } catch (err) {
      console.error(err)
    }
  }
  const editNote = async (note) => {
    let params = {}
    if (sampleId) {
      params = {
        annotationContent: note.annotationContent,
        annotationUrl: note?.annotationUrl || '',
        entityId: sampleId,
        inspirationId: sampleInspirationId,
        id: note.id,
        mainUrl: imageInfo.mainUrl,
        targetId: sampleCode,
        xmax: round(note.xmax, 4),
        xmin: round(note.xmin, 4),
        ymax: round(note.ymax, 4),
        ymin: round(note.ymin, 4),
        type: 1
      }
    } else {
      params = {
        annotationContent: note?.annotationContent || '',
        annotationUrl: note?.annotationUrl || '',
        entityId: imageGroupEntityId,
        inspirationId,
        id: note.id,
        mainUrl: imageInfo.mainUrl,
        targetId: collectId,
        xmax: round(note.xmax, 4),
        xmin: round(note.xmin, 4),
        ymax: round(note.ymax, 4),
        ymin: round(note.ymin, 4),
        type: 0
      }
    }
    try {
      await request.post('/zhikuan/annotation/modify-blog-annotation', params)
      setNotes(pre => {
        return pre.map(item => {
          if (item.id === note.id) {
            return {
              ...item,
              ...note
            }
          }
          return item
        })
      })
    } catch (err) {
      console.error(err)
    }
  }
  const onOk = async (note, e) => {
    e.stopPropagation()
    if (note.confirm) {
      note.editMode = false
      if (!note.annotationContent && !note.annotationUrl) return message.warning('文字内容和图片至少一项不为空')
      await editNote(note)
      return
    }
    if (!note.annotationContent && !note.annotationUrl) return message.warning('文字内容和图片至少一项不为空')
    note.confirm = true
    util.track('mn-inspiration-annotation', {
    })
    setIsAnnotate(false)
    await saveNote(note)
    fetchNotes(imageInfo)
  }
  const onCancel = (note, e) => {
    e?.stopPropagation()
    if (note?.confirm) {
      note.editMode = false
      setNotes(pre => [...pre])
      return
    }
    setActiveNoteIndex(pre => pre - 1)
    setNotes(pre => pre.filter(m => m.confirm))
  }
  const onEdit = (note, e) => {
    e.stopPropagation()
    setNotes(pre => {
      return pre.map(item => {
        if (note.id === item.id) {
          return {
            ...item,
            editMode: true
          }
        }
        return {
          ...item,
          editMode: false
        }
      })
    })
  }

  const onDelete = async (note, e) => {
    e.stopPropagation()
    ModalConfirm.show({
      title: '确定要删除该批注吗？',
      content: '当批注被删除后，该批注的内容将不可恢复',
      onOk: async () => {
        try {
          deleteNote(note)
        } catch (err) {
          message.error('删除失败，请稍后再尝试删除')
        }
      }
    })
  }

  const deleteNote = async (note) => {
    try {
      await request.post('/zhikuan/annotation/delete-blog-annotation', {
        entityId: note?.entityId,
        inspirationId: note?.inspirationId,
        id: note.id,
        mainUrl: note?.mainUrl,
      })
      setNotes(pre => pre.filter(m => m !== note))
      setIsMove(false)
      onChange?.({ annotationNum: notes.filter(m => m.id !== note.id).length })
    } catch (err) {
      console.error(err)
      if (err.errorCode === 'U04') {
        message.error('没有删除权限')
      }
    }
  }

  const mouseMove = (e) => {
    babelMouseEvent(e)
    if (isDarg) {
      calculatePosition({
        ...imageInfo,
        ...originImage,
        translate: {
          x: (e.clientX - LEFT) - dragStartPos.current.x,
          y: e.clientY - dragStartPos.current.y
        }
      })
      return
    }
    if (isDraw) {
      const note = notes[0]
      if ((e.clientX - LEFT) >= drawStartPos.current.x) {
        note.xmin = (drawStartPos.current.x - position.left) / position.width
        note.xmax = ((e.clientX - LEFT) - position.left) / position.width
      } else {
        note.xmin = ((e.clientX - LEFT) - position.left) / position.width
        note.xmax = (drawStartPos.current.x - position.left) / position.width
      }
      if (e.clientY >= drawStartPos.current.y) {
        note.ymin = (drawStartPos.current.y - position.top) / position.height
        note.ymax = (e.clientY - position.top) / position.height
      } else {
        note.ymin = (e.clientY - position.top) / position.height
        note.ymax = (drawStartPos.current.y - position.top) / position.height
      }
      if (note.xmax > 1 || note.ymax > 1 || note.xmin < 0 || note.ymin < 0) {
        note.xmax = Math.min(note.xmax, 1)
        note.xmin = Math.max(note.xmin, 0)
        note.ymax = Math.min(note.ymax, 1)
        note.ymin = Math.max(note.ymin, 0)
      }
      setNotes([...notes])
    }
    if (isMove) {
      const note = notes[activeNoteIndex]
      if (note.xmax + ((e.clientX - LEFT) - moveStartPos.current.x) / position.width > 1
        || note.ymax + (e.clientY - moveStartPos.current.y) / position.height > 1
        || note.xmin + ((e.clientX - LEFT) - moveStartPos.current.x) / position.width < 0
        || note.ymin + (e.clientY - moveStartPos.current.y) / position.height < 0) {
        return
      }
      note.xmin += ((e.clientX - LEFT) - moveStartPos.current.x) / position.width
      note.xmax += ((e.clientX - LEFT) - moveStartPos.current.x) / position.width
      note.ymin += (e.clientY - moveStartPos.current.y) / position.height
      note.ymax += (e.clientY - moveStartPos.current.y) / position.height
      moveStartPos.current = { x: (e.clientX - LEFT), y: e.clientY }
      setNotes([...notes])
    }
  }

  useEffect(() => {
    window.addEventListener('mouseup', mouseUp)
    window.addEventListener('touchend', mouseUp)
    return () => {
      window.removeEventListener('mouseup', mouseUp)
      window.removeEventListener('touchend', mouseUp)
    }
  }, [isDarg, isDraw, isMove])

  const mouseUp = () => {
    if (isDarg) {
      setIsDrag(false)
      return
    }
    if (isDraw) {
      setIsDraw(false)
      return
    }
    if (isMove) {
      setIsMove(false)
      const note = notes[activeNoteIndex]
      if (note.confirm) {
        editNote(note)
      }
    }
  }

  useEffect(() => {
    if (query.typeId && query.type === 'notation' && document.querySelector(`[data-id='${query.typeId}']`)) {
      document.querySelector(`[data-id='${query.typeId}']`).scrollTop = 0
      move.start(6)
    }
  }, [notes])

  return <div className={classNames('meinian-annotate', className)} onMouseMove={mouseMove} onTouchMove={mouseMove}>
    <div
      className="image-container"
      ref={$container}
      onMouseDown={dragStart}
      onTouchStart={dragStart}
      style={{
        height: document.body.clientHeight
      }}
    >
      {!loading ? <div className="image-wrapper" ref={$wrapper} style={{ ...position }} onMouseDown={drawStart} onTouchStart={drawStart}>
        <img draggable="false" src={imageInfo.mainUrl} className={classNames('image', { annotate: isAnnotate })} onMouseDown={e => e.preventDefault()} />
        {
          notes.map((note, index) => <Note
            data={note}
            root={$container}
            loginUserInfo={imageInfo.loginUserInfo}
            imagePosition={position}
            index={notes.length - index}
            active={index === activeNoteIndex && note?.isShowNote}
            showNote={!isDraw && !(isAnnotate && note.confirm) && note?.isShowNote}
            onOk={onOk}
            onCancel={onCancel}
            onEdit={onEdit}
            onDelete={onDelete}
            setNotes={setNotes}
            onMouseDown={(_, e) => { !isAnnotate && move.start(index, e) }}
            canMove={!note.confirm || userInfo.userId === note.userId}
          />)
        }
      </div> : null}
    </div>
  </div>
}
